import React, { useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await API.post('token/', { username, password });
            // حفظ التوكن في localStorage
            localStorage.setItem('token', res.data.access);
            navigate('/'); // تحويل المستخدم للـ Dashboard
        } catch (err) {
            setError(t('Invalid username or password'));
        }
    };

    return (
        <div className="login-page">
            <div className="card login-card">
                <h2>{t('Login')}</h2>
                {error && <p className="login-error">{error}</p>}
                <form onSubmit={handleLogin}>
                    <input
                        className="input"
                        type="text"
                        autoComplete="username"
                        placeholder={t('Username')}
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required
                    />
                    <input
                        className="input"
                        type="password"
                        autoComplete="current-password"
                        placeholder={t('Password')}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                    />
                    <button className="btn btn-primary" type="submit">{t('Login')}</button>
                </form>

            </div>
        </div>
    );
}

export default Login;
